export default __webpack_public_path__ + "static/media/arrowBack.b8d25458.svg";